import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

//Material UI
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Search from '@material-ui/icons/Search';

//Zustands
import { useDepositStore } from 'useStores/useDepositStore';

//Packages
import { isMobile } from 'react-device-detect';
import { useForm } from 'react-hook-form';
import moment from 'moment-jalaali';
import { useIsFetching } from 'react-query';

//Hooks
import { useSearchParams } from 'hooks/useSearchParams';

//Components
import Accordion from '../../../../../components/Accordion/Accordion';
import DatePicker from '../../../../../components/TextFields/DatePicker';
import UsersChip from '../../../../../components/Chip/UsersChip/UsersChip';
import { useMainStore } from 'useStores/useMainStore';
import useRules from 'hooks/useRules';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(7,1fr)',
    gridGap: theme.spacing(1),
    '& > *': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  button: {
    cursor: 'pointer',
  },
}));

const Filters = () => {
  const progress = useIsFetching(['commissionReports', window.location.search]);
  const classes = useStyles();
  const [rules, hasRule, isAdmin] = useRules();

  const selectedUser = useDepositStore((state) => state.selectedUser);
  const setSelectedUser = useDepositStore((state) => state.setSelectedUser);
  const limit = useMainStore((state) => state.limit);

  const [params, setParams] = useSearchParams();
  const [startDate, setStartDate] = useState(
    params.get('endDate')
      ? moment(params.get('startDate'))
      : moment().startOf('jMonth')
  );

  const [endDate, setEndDate] = useState(
    params.get('endDate') ? moment(params.get('endDate')) : moment()
  );
  const { register, handleSubmit } = useForm();
  const history = useHistory();

  const onSubmit = (data) => {
    const urlParams = new URLSearchParams('');
    const roles = Object.entries(data).filter((item) => item[1]);
    roles.map((role) => urlParams.append('role', role[0]));
    urlParams.append('startDate', startDate.startOf('day').toISOString());
    urlParams.append('endDate', endDate.endOf('day').toISOString());
    urlParams.append('limit', limit);
    selectedUser.length > 0
      ? urlParams.append('user', selectedUser?.[0]?._id)
      : urlParams.delete('user');
    const pathName = history.location.pathname;
    history.push(`${pathName}?${urlParams.toString()}`);
  };

  const handleChangeStartDate = (date) => {
    setStartDate(date);
  };
  const handleChangeEndDate = (date) => {
    setEndDate(date);
  };

  const handleChangeUser = (user) => {
    setSelectedUser(user);
  };

  useEffect(() => {
    !params.get('user') && setSelectedUser([]);
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Accordion title="فیلترهای گزارش" open={isMobile ? false : true}>
        <div className={classes.root}>
          <DatePicker
            label="از ماه"
            value={startDate}
            onChange={handleChangeStartDate}
            disabled={progress === 1 ? true : false}
            format={'jD jMMMM jYYYY'}
          />
          <DatePicker
            label="تا ماه"
            value={endDate}
            onChange={handleChangeEndDate}
            disabled={progress === 1 ? true : false}
            format={'jD jMMMM jYYYY'}
          />
          <UsersChip
            single
            onChange={handleChangeUser}
            defaultUser={selectedUser}
          />
          <FormControlLabel
            control={
              <Checkbox
                {...register('customer')}
                name="customer"
                defaultChecked={
                  params.getAll('role').includes('customer') || false
                }
              />
            }
            label="صاحبین بار"
          />
          <FormControlLabel
            control={
              <Checkbox
                {...register('driver')}
                name="driver"
                defaultChecked={
                  params.getAll('role').includes('driver') || false
                }
              />
            }
            label="رانندگان"
          />
          {hasRule('can_report_operators_commissions_deposited') && (
            <FormControlLabel
              control={
                <Checkbox
                  {...register('admin')}
                  name="admin"
                  defaultChecked={
                    params.getAll('role').includes('admin') || false
                  }
                />
              }
              label="کارشناسان حمل"
            />
          )}

          <Button
            variant="contained"
            color="secondary"
            className={classes.button}
            startIcon={<Search />}
            type="submit"
          >
            جست و جو
          </Button>
        </div>
      </Accordion>
    </form>
  );
};

export default React.memo(Filters);
